export default "__VITE_ASSET__ead30692__"